import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocumentSearch = () => {
  return (
    <g>
      <path d="m4.942.005 7.014.012c.54.001.985.41 1.042.936l.006.114.002 3.997A4.244 4.244 0 0 1 14.755 8.5a4.23 4.23 0 0 1-.761 2.427l1.786 1.788a.75.75 0 0 1-.977 1.133l-.084-.073-1.715-1.714v2.889c0 .541-.41.987-.936 1.044l-.114.006H1.05a1.05 1.05 0 0 1-1.044-.936L0 14.95V4.94L4.942.004zM6 1.505V4.95c0 .541-.409.987-.935 1.044L4.952 6H1.5v8.5h10.004v-1.868a4.25 4.25 0 1 1 0-8.263V1.514L6 1.505zm4.502 4.245a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5zM4.501 2.563 2.562 4.5h1.94L4.5 2.562z" />
    </g>
  );
};

export default withIcon(IconDocumentSearch);
